$.urlParam = function(name){
  var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
  if (results==null){
    return null;
  }
  else{
    return results[1] || 0;
  }
};

window.facebookPixelLeadSent = false;

window.trackEvent = function(category, action, metric) {
  if (trackersGoogleAnalytics.enabled) {
    ga('send', 'event', category, action, Campaign.internal_name, metric);
  }

  if (trackersPiwik.enabled) {
    Piwik.getTracker().trackEvent(category, action, Campaign.internal_name, metric);
  }

  if (trackersFacebookPixel.enabled) {
    var data = {}
    if (metric !== undefined) {
      data = {
        value: metric,
        currency: Settings.donations.currency
      };
    };
    fbq('trackCustom', category+'_'+action, data);

    if (action.startsWith('action') && !facebookPixelLeadSent) {
      fbq('track', 'Lead');
      facebookPixelLeadSent = true;
    }
  };
};

window.isMobile = function() {
  if(window.innerWidth <= 800 && window.innerHeight <= 600) {
    return true;
  }
  else {
    return false;
  }
};

window.setGUID = function(guid) {
  var domain = location.host.split(':')[0];
  document.cookie = "guid=" + guid + "; path=/; domain="+domain;
}

window.channelUrl = function(medium, url, message) {
  // insert url into {url} placeholder in message or append to message
  if (message.indexOf("{url}") >= 0) {
    message = message.replace("{url}", url);
  } else {
    message = message + " " + url;
  }
  var encodedMessage = encodeURIComponent(message);

  switch(medium) {
  case 'facebook':
    return "http://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(url);
    break;
  case 'twitter':
    return "http://twitter.com/intent/tweet?text=" + encodedMessage;
    break;
  case 'whatsapp':
    return "whatsapp://send?text=" + encodedMessage;
    break;
  case 'sms':
    return plinks.smsLink(message);
    break;
  case 'email':
    return "mailto:?subject="+encodeURIComponent(Campaign['name'])+"&body="+encodedMessage;
    break;
  default:
    return message;
  }
}

function getRecentActions() {

  $.ajax({
    dataType: 'json',
    url: '/campaigns/' + window.Campaign.id + '/recent_actions',
    method: 'get'
  }).done(function(response) {

    if (typeof response.actions !== 'undefined') {

      recentActions = response.actions;
      setTimeout(getRecentActions, 60000);

      if (!recentActionShown) {

        recentActionShown = true;
        cycleRecentAction();
      }
    }
  });
}

function cycleRecentAction() {

  if (currentActionIndex >= recentActions.length) {

    currentActionIndex = 0;
  }
  $('.js-recent-action').fadeOut('slow', function() {

    $('.js-recent-action span').text(recentActions[currentActionIndex].text);
    $('.js-recent-action').removeClass('hidden');
    $('.js-recent-action').fadeIn('slow');
    currentActionIndex++;
    setTimeout(cycleRecentAction, 5000);
  });
}

$(document).ready(function() {
  $('[data-toggle="tooltip"]').tooltip();

  webshims.polyfill('forms');
  //autoscroll to
	$("#fixed-sign button.btn-primary").click(function(){
        $('#rsign .action-form').parent().show();
        $('#rsign .advice-container').parent().hide();
        $('#fixed-sign').hide();
        $('#return-to-petition').show();
        $('#rsign_name').focus();

		var top = $('#return-to-petition').offset().top - 10;
		$("html, body").animate({ scrollTop: top }, 500);
	});

  $("#return-to-petition").click(function(){
    $('#rsign .action-form').parent().hide();
    $('#rsign .advice-container').parent().show();
    $('#fixed-sign').show();
    $('#return-to-petition').hide();
    $("html, body").animate({ scrollTop: 0 }, 500);
  });


  // apply shims

  // donations
  // select recuring-donation state. it is .js-recurring-donation class on
  // .donation-container. (also a reverse: .js-one-off-donation class is
  // unset/set respectively)
  // Finally, an rdonate recurring input field is set properly
  function setRecurrence(is_recurring) {
    if (is_recurring) {
      $(".donation-container").addClass("js-recurring-donation").removeClass("js-one-off-donation");
      $("[name='rdonate[recurring]']").val('true');
      /* CHANGE TEXT "PAYPAL" TO "PAYPAL MONTHLY" AND ADD VARIOUS MARGINS: */
        var pp_button_ch = document.getElementById("donate-by-paypal-button").children;
        pp_button_ch[1].innerText = "Paypal Monthly";
        pp_button_ch[1].style = "margin-right: -24px";
        pp_button_ch[0].style = "margin-left: -24px";
        document.getElementById("donate-by-card-button").children[0].style = "margin-left: -24px";
        document.getElementsByClassName("direct-debit-label")[0].style = "margin-right: -24px";
    } else {
      $(".donation-container").removeClass("js-recurring-donation").addClass("js-one-off-donation");
      $("[name='rdonate[recurring]']").val('false');
      /* CHANGE TEXT "PAYPAL MONTHLY" TO "PAYPAL" AND REMOVE THE CHANGED MARGINS */
        var pp_button_ch = document.getElementById("donate-by-paypal-button").children;
        pp_button_ch[1].innerText = "Paypal";
        pp_button_ch[1].style = "";
        pp_button_ch[0].style = "";
        document.getElementById("donate-by-card-button").children[0].style = "";
        document.getElementsByClassName("direct-debit-label")[0].style = "";
    }
  }

  // Handle button to toggle recurring donation
  $(".recurring-donation-toggle-buttons a").click(function(ev) {
    ev.preventDefault();
    var clicked = $(this);
    clicked.siblings("a").removeClass("selected");
    clicked.addClass("selected");
    setRecurrence(clicked.is(".js-recurring-donation-true"));
  });

  // Handle fake checkbox based toggle of recurring donation
  $('.js-recurring-donation').on('change', function(e) {
    setRecurrence($(this).is(':checked'));
  });

  // make fake checkbox icon clickable
  $('.fake-checkbox .fake-checkbox-icon').on('click', function(ev){
    var real = $(this).closest('.fake-checkbox').find('input[type=checkbox]').get(0)
    if (typeof real !== 'undefined') {
      real.click();
    }
  });

  // Display fake checkbox
  $('.fake-checkbox input[type=checkbox]').on('change', function(ev){
    var real_checkbox = this;
    var fake = $(this).closest('.fake-checkbox').find('.fake-checkbox-icon').get(0)

    if (real_checkbox.checked){
      fake.classList.remove('glyphicon-unchecked');
      fake.classList.add('glyphicon-check');
    } else {
      fake.classList.remove('glyphicon-check');
      fake.classList.add('glyphicon-unchecked');
    }
  });

  // handle toggling buttons like one under .recurring-donation-toggle-buttons
  $(".js-toggles a.js-toggle").click(function(ev) {
    ev.preventDefault();
    var clicked = $(this);
    clicked.siblings("a.js-toggle").removeClass("selected");
    clicked.addClass("selected");
    var input_name = clicked.closest('.js-toggles').data('input');
    var input = $('[name="'+input_name+'"]').get(0);
    if (input.type == 'checkbox') {
      input.checked = clicked.data('value');
    } else {
      input.value = clicked.data('value');
    }
  });

  var showMonthlyAmount = function(amount) {
    // If the monthly amount isn't a valid number, just show 0
    var monthlyDisplayAmount = isNaN(amount * 4.33) ? 0 : amount * 4.33;
    $('.js-donation-weekly-display-amount').text(monthlyDisplayAmount);
  };


  var useCustomAmount = function() {
    $('.js-donation-block').removeClass('selected');
    $('.js-custom-amount').addClass('selected');

    updateAmount();
  }
  $('.js-custom-amount').on('change', useCustomAmount);
  if ($('.js-custom-amount').val() != '') {
    useCustomAmount();
  }


  $('.js-donation-block').on('click', function(ev) {
    ev.preventDefault();
    $('.js-donation-block,.js-custom-amount').removeClass('selected');
    $('.js-custom-amount').val('');
    $(this).addClass('selected');
    updateAmount();
  });

  function updateAmount() {
    var amount = $('.js-donation-block.selected').data('js-donation-amount');
    if(!amount && $('.js-custom-amount').val() !== undefined) {
      amount = $('.js-custom-amount').val().replace(Settings.donations.currency_symbol,"");
    }

    amount = Number(amount);

    if($('.js-processing-fee').prop('checked')) {
      amount = amount + Number(window.Campaign.processing_fee_amount || 0.3);
    }

    $('.js-donation-display-amount').text(amount.toFixed(2));
    showMonthlyAmount(amount);
    if( getDonationType() == 'weekly' ) {
      $('.js-donation-form-amount').val(amount * 4.33);
    } else {
      $('.js-donation-form-amount').val(amount);

    }
  }
  $('.js-processing-fee').on('change', updateAmount);

  function getAmount() {
    var amount = document.querySelector('.js-donation-form-amount');
    if (amount) {
      var value = parseFloat(amount.value.replace("£",""));
      return isNaN(value) ? undefined : value;
    } else {
      return undefined;
    }
  }

  /* ~ validate ~ */
  function validateAmount() {
    var value = getAmount();
    if (value) {
      return isFinite(value)
        /* && Math.floor(value*100) == (value*100) */ /* removed 30 Mar 2021, this causes validation errors, e.g., on values like 8.7: (8.7*100 becomes 869.99) */
        && value > 0;
    } else {
      return false;
    }
  }

  var isGoCardless = function() { return Settings.direct_debits.backend === 'gocardless'; };

  var needsUpsell = function() {
    if(!$('.js-donation-upsell').length) { return false }
    if($('.js-donation-upsell').is(":visible")) { return false }
    if(getDonationType() === 'weekly' || getDonationType() === 'monthly') { return false }

    return true;
  }
  var upsellType;
  var upsellAmount;
  var showUpsell = function(paymentType) {
    upsellType = paymentType;
    var selectedAmount = +($('.js-donation-display-amount').first().text());
    var minimumUpsell = +($('.upsell-donate-buttons').data('js-minimum-upsell-amount'));
    var upsellConversionFactor = (+($('.upsell-donate-buttons').data('js-upsell-conversion-factor'))) * 0.01;
    upsellAmount = Math.max(minimumUpsell, selectedAmount * upsellConversionFactor)
    var upsellText = ((upsellAmount % 1) === 0) ? upsellAmount : upsellAmount.toFixed(2); // show 2 decimal places if not a whole number
    $('.js-donation-upsell-display-amount').text(upsellText)
    $('.js-donation-upsell').show()
  }

  $('.js-donate-no-upsell').on('click', function(ev){
    ev.preventDefault()
    if(upsellType === 'paypal') {
      triggerPaypalDonate();
    } else {
      $('.js-donation-amount, .js-donation-upsell').hide();
      $('.js-donation-details').show();
    }
  })

  $('.js-donate-upsell').on('click', function(ev) {
    ev.preventDefault()
    $('.js-donation-form-amount[name=donation_amount_monthly]').val(upsellAmount)
    $('input.js-recurring-donation')[0].click();
    if(upsellType === 'paypal') {
      triggerPaypalDonate();
    } else {
      triggerGoCardlessDonate();
    }
  })

  /* ~ navigation ~ */
  /*   backward     */
  $('.js-back-to-donation-amount').on('click', function(ev) {
    ev.preventDefault();
    $('.js-donation-amount').show();
    $('.js-donation-details').hide();
  });
  /*   forward      */
  $('.js-donate-next').on('click', function(ev) {
    ev.preventDefault();
    if(validateAmount()){
      // For GoCardless we redirect off the site to their hosted form, so need a different handling
      if (isGoCardless() && (getDonationType() === 'weekly' || getDonationType() === 'monthly')) return triggerGoCardlessDonate();

      if(needsUpsell()) {
        $('.js-donation-amount').hide();
        showUpsell('card')
      } else {
        $('.js-donation-amount, .js-donation-upsell').hide();
        $('.js-donation-details').show();
      }
    }
    else {
      /* XXX alert -> some nicer feedback? */
      alert(Settings.validation_errors['donate']);
    }
  });
  $('.js-processing-next').on('click', function(ev) {
    if ($(this).closest('form').checkValidity()) {
      $('.js-donation-details').hide();
      $('.js-donation-processing').show();
    }
  });

  /* Trigger paypal */
  $('.js-donate-paypal').on('click', function (e) {
      if (validateAmount()) {
          if(needsUpsell()) {
            $('.js-donation-amount').hide();
            showUpsell('paypal');
          } else {
            triggerPaypalDonate();
          }
      }
      else {
          alert("Please make sure you're contributing a valid amount.");
      }
  });

  /* ~ confirmation interceptor ~ */
  $(document).on('click', 'a[data-confirm]', function (ev) {
    var message = $(this).data('confirm');
    if (!confirm(message)) {
      ev.preventDefault();
      ev.stopped = true;
    }
  });

  // Global personalisation disabler
  $('.js-not-you').on('click', function(ev) {
    ev.preventDefault();

    $(".member-is-known").removeClass('member-is-known member-has-already-signed');

    $("input[name=use_known_member_data]").val("false");
    $("input[name=known_member_data]").val("");

    // js-personalised-* is used in donations
    $('.js-personalised-element .js-personalised-text').addClass('hidden');
    $('.js-personalised-element .js-unpersonalised-text').removeClass('hidden');

    // ->CSS // $('.known-member').hide();

    // clean prefilled fields
    // 99% of time will be empty anyway, but eg. DirectDebit and some other forms may populate name ONLY directly into the form
    $('.hideIfComplete input, .hideIfComplete select, .js-prefilled-input input, .hideIfMemberKnown input').val('');
    $('.hideIfComplete input, .hideIfComplete select, .js-prefilled-input input, .hideIfMemberKnown input').attr('disabled', false);
    $('.hideIfComplete, .hideIfMemberKnown').parent().show();
    var domain = location.host.split(':')[0];
    var higherDomain = domain.substr(domain.indexOf('.')+1);
    document.cookie = "guid=; path=/; domain="+domain+"; expires=Thu, 01 Jan 1970 00:00:01 GMT;";
    document.cookie = "guid=; path=/; domain="+higherDomain+"; expires=Thu, 01 Jan 1970 00:00:01 GMT;";
    document.cookie = "member=; path=/; domain="+domain+"; expires=Thu, 01 Jan 1970 00:00:01 GMT;";

    showConsentInputs();
  });

  $('.js-character-count-input textarea,.js-character-count-input input').on('keyup', function(e) {
    var length = $(this).val().length;
    var parent = $(this).closest('.js-character-counter');
    var counter = $('.js-character-count-value', $(parent));
    counter.html(length);
    if (length > 140) {
      counter.addClass('character-count-over-limit');
    }
    else {
      counter.removeClass('character-count-over-limit');
    }
  });

  $('.js-track-action').on('click', function(event) {
    // This is used in lots of places, and not all of them might use a form
    // So check there is a form before testing if it is valid.
    if (event.target.form && !(new MemberForm(event.target.form)).is_valid()) {
      return;
    }

    var category = $(this).data('js-event-category');
    var action = $(this).data('js-event-action');
    var metric = $(this).data('js-event-metric');
    if (metric) {
      metric = parseInt(metric);
    } else {
      metric = 0;
    }

    trackEvent(category, action, metric);
  });


  $('.js-ga-action').on('click', function() {
    if (trackersGoogleAnalytics.enabled) {
      var actionName = $(this).data('js-ga-action');
      var actionDimension = $(this).data('js-ga-dimension');
      ga('send', 'event', actionName, 'click', actionDimension);
    }

    if (trackersPiwik.enabled) {
      var number = $(this).data('js-event-numeric');
      if (number) {
        number = parseInt(number);
      }
      piwik.trackEvent($(this).data('js-event-category'),
                       $(this).data('js-event-action'),
                       Campaign.slug,
                       number
                      );
    }
  });

  $('.js-are-you-abroad a').on('click', function(ev) {
    ev.preventDefault();
    var form = $(this).closest('form');
    form.find(".js-member-postcode").find('input').val(Settings.zip_placeholder).removeAttr('required').parent().parent().hide();
    form.find(".js-member-country").closest(".hidden").removeClass("hidden");
    $(this).parent().hide();
  });


  if (Settings.email.validate) {
    $('.js-member-email input').on('blur', function() {
      $(this).mailcheck({
        domains: Mailcheck.defaultDomains.concat(Settings.email.domains),
        secondLevelDomains: Mailcheck.defaultSecondLevelDomains.concat(Settings.email.slds),
        topLevelDomains: Mailcheck.defaultTopLevelDomains.concat(Settings.email.tlds),
        suggested: function(element, suggestion) {
          var hint = element.next('.mailcheck-hint').show();
          if (hint.length==0) {
            hint = $('<div class="mailcheck-hint"></div>').insertAfter(element);
            hint.on('click', 'span', function(evt) {
              var fix = $(evt.target).text();
              element.val(fix).blur();
            });
          }
          hint.html(Settings.validation_errors.mailcheck_hint.replace("%{suggestion}", suggestion.full));
        },
        empty: function(element) {
          var hint = element.next('.mailcheck-hint');
          hint.hide();
        }
      });
    });
  }


  //  $('[type="submit"]').on('click', function(){
  //   standard_validators();
  //  });

  /*  $('.js-submit').on('click', function() {
   var form = $(this).closest('form');

   $(function () {
   var decide_classes = $("[class^='decideOnce-']")
   .map(function (i, e) { return $(e).attr('class') })
   .toArray();
   var unique_classes = decide_classes.filter(function (item, pos) { return decide_classes.indexOf(item) == pos });

   $.each(unique_classes, function (i, e) {
   console.log(form.find('.' + e + ' input[type="checkbox"]'));
   $('.' + e + ' input[type="checkbox"]').prop('checked', form.find('.' + e + ' input[type="checkbox"]').prop('checked'));
   $('.' + e).parent().hide()
   });
   });

   });
   */

  $('[type="submit"],.js-submit').on('click', function(ev){
    var frm = new MemberForm($(this).closest('form')[0]);
    if (! frm.is_valid()) {
      ev.preventDefault();
    } else {
      preSubmitConsentLogic($(this).closest('form'), ev);
    }
  });

  function getRecentActions() {
    $.ajax({
      dataType: 'json',
      url: '/campaigns/' + window.Campaign.id + '/recent_actions',
      method: 'get'
    }).done(function(response) {

      if (typeof response.actions !== 'undefined') {

	      recentActions = response.actions;
	      setTimeout(getRecentActions, 60000);

	      if (!recentActionShown) {

	        recentActionShown = true;
	        cycleRecentAction();
	      }
      }
    });
  }

  function cycleRecentAction() {
    if (currentActionIndex >= recentActions.length) {
      currentActionIndex = 0;
    }

    $('.js-recent-action').fadeOut('slow', function() {
      $('.js-recent-action .js-text').text(recentActions[currentActionIndex].text);
      $('.js-recent-action .js-time-ago span').text(recentActions[currentActionIndex].time_ago);
      if ($('.js-recent-action .js-time-ago span')[0].innerText == "") {
        $('.js-recent-action .js-time-ago span')[0].parentNode.style.display = "none";
      } else {
        $('.js-recent-action .js-time-ago span')[0].parentNode.style.display = "block";
      }
      $('.js-recent-action').removeClass('hidden');
      $('.js-recent-action').fadeIn('slow');
      currentActionIndex++;
      setTimeout(cycleRecentAction, 5000);
    });
  }

  // enable live updates if element present
  if ($('.js-recent-action').length > 0) {
    if (window.innerWidth > 1180) {

      var currentActionIndex = 0;
      var recentActions = [];
      var recentActionShown = false;

      getRecentActions();
    }
  }

/* ********* recent contributions ********** */
function getRecentContribs() {
  $.ajax({
    dataType: 'json',
    url: '/campaigns/' + window.Campaign.id + '/recent_contribs',
    method: 'get'
  }).done(function(response) {
    if (typeof response.contribs !== 'undefined') {
      recentContribs = response.contribs;
      setTimeout(getRecentContribs, 60000);
      if (!recentContribShown) {
        recentContribShown = true;
        cycleRecentContrib();
      }
    }
  });
}
function cycleRecentContrib() {
  if (currentContribIndex >= recentContribs.length) {
    currentContribIndex = 0;
  }
  $('.js-recent-contrib').fadeOut('slow', function() {
    $('.js-recent-contrib .js-text').text(recentContribs[currentContribIndex].text);
    $('.js-recent-contrib .js-time-ago span').text(recentContribs[currentContribIndex].time_ago);
    if ($('.js-recent-contrib .js-time-ago span')[0].innerText == "") {
      $('.js-recent-contrib .js-time-ago span')[0].parentNode.style.display = "none";
    } else {
      $('.js-recent-contrib .js-time-ago span')[0].parentNode.style.display = "block";
    }  
    $('.js-recent-contrib').removeClass('hidden');
    $('.js-recent-contrib').fadeIn('slow');
    currentContribIndex++;
    setTimeout(cycleRecentContrib, 5000);
  });
}
// enable recent contribs if element present
var currentContribIndex = 0;
var recentContribs = [];
var recentContribShown = false;
if ($('.js-recent-contrib').length > 0) {
  if (window.innerWidth > 1180) {
    getRecentContribs();
  }
}
/* ********** end ********** */
    
  var applySelectize = function(rootElement, includeDelay) {
    $('.js-selectize', rootElement).each(function(index) {
      var fieldName, ajaxRoute;
      if ($(this).hasClass('js-selectize-area')) {
        fieldName = 'name';
        ajaxRoute = '/areas/search';
      }
      else if ($(this).hasClass('js-selectize-representative')) {
        fieldName = 'name';
        ajaxRoute = '/representatives/search';
      }
      else if ($(this).hasClass('js-selectize-decision')) {
        fieldName = 'name';
        var campaignId = $(this).data('campaign-id');
        ajaxRoute = '/decisions/' + campaignId + '/search';
      }
      else if ($(this).hasClass('js-selectize-organisation')) {
        fieldName = 'name';
        ajaxRoute = '/representatives/search';
      }
      else {
        console.log('Invalid use of selectize-ajax element: no valid subclass specified.');
        return;
      }
      $(this).selectize({
        maxItems: 1,
        valueField: 'id',
        labelField: 'name',
        searchField: 'name',
        maxOptions: 25,
        render: {
          option: function(item, escape) {
            return '<div>' +
              '<span class="title">' +
              '<span class="name">' + escape(item[fieldName]) + '</span>' +
              '</span>' +
              '</div>';
          }
        },
        load: function(query, callback) {
          if (!query.length) {
            return callback();
          }
          $.ajax({
            url: ajaxRoute + '?query=' + encodeURIComponent(query),
            type: 'GET',
            dataType: 'JSON',
            error: function() {
              callback();
            },
            success: function(res) {
              callback(res.slice(0, 10));
            }
          });
        }
      });
    });

    $('.js-selectize-options', rootElement).each(function(){
      $(this).selectize({create: true})
    })
  }
  applySelectize($('body'));
});


function validateAmount(){
    amount    = document.getElementsByName("amount")[0].value.replace("£", "");
    dd_amount = document.getElementsByName("donation_amount_monthly")[0].value.replace("£", "");
  value     = 0;
  if ( amount ) {
    value = amount.value;
  }
  else {
    value = dd_amount.value;
  }
  console.log("app.js - value - " + value);
  return !isNaN(parseFloat(value)) && isFinite(value) && value > 0;
}


function getDonationType(){
  if ( $('.js-journey-monthly_direct_debit').length >= 1 ) {
      return 'monthly';
  }       
  if ( $('.js-recurring-donation').length >= 1 ) {
    if ( $('.js-recurring-donation').is(':checked') ) {
	return 'monthly';
    }
    else {
      return 'one-off';
    }
  }
  else {
    if ( $('#direct-debit-form').length == 1 ) {
      return 'weekly';
    }
    else {
      return 'one-off';
    }
  }
}


function triggerPaypalDonate(){
  console.log(getDonationType());
  if (getDonationType() == 'weekly' || getDonationType() == 'monthly'){
    var amount = $('.js-donation-form-amount[name=donation_amount_monthly]').val();
    if (amount != undefined) { amount = amount.replace("£",""); }
    var $form = $('form#paypal-regular-donation');
    $form.find('input[name=a3]').val(amount);
    $form.submit();
  } else {
    var amount = $('.js-donation-form-amount[name="rdonate[amount]"]').val();
    if (amount != undefined) { amount = amount.replace("£",""); }
    var $form = $('form#paypal-one-off-donation');
    $form.find('input[name=amount]').val(amount);
    $form.submit();
  }
}

var triggerGoCardlessDonate = function() {
  var monthly_amount = $('.js-donation-form-amount[name=donation_amount_monthly]').val();
  if (monthly_amount != undefined) { monthly_amount = monthly_amount.replace("£",""); }

  $.post('/gocardless/create_redirect_flow', { monthly_amount:monthly_amount, campaign_id: Campaign.id }, function(resp){
    if (resp.redirect_url) window.location.href = resp.redirect_url;
  });
}

/*
 Validators
*/

function standard_validators() {
    var to_validate = ['representative', 'name', 'phone', 'consent'];
    for (var i = 0; i < to_validate.length; i++) {
        standard_element_validation(to_validate[i]);
    }
};

function standard_element_validation(element_name) {
    var possible_inputs = ['input', 'select', 'textarea'];
    var parent_selector = '.js-member-' + element_name;
    var element;
    for (var i = 0; i < possible_inputs.length; i++) {
        var input = possible_inputs[i];
        var elements = $(parent_selector + ' ' + input);
        elements.each(function() {
            validate_or_alert($(this), element_name, parent_selector);
        });
    }
};

function email_validation(form) {
    var emailElement = form.find('.js-member-email input');
    if (emailElement.length) {
        var email = emailElement.val().replace(/\s/g, "");
        var regex = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/i;
        if (!regex.test(email)) {
            emailElement.addClass('invalid-form-element');
            emailElement.parent().show();

            // add error message if missing
            // convert to error_messages_for / _on ?
            if (emailElement.parent().children('.invalid-form-element-error').length == 0) {
                $(emailElement).parent().append('<div class="invalid-form-element-error">' + Settings.validation_errors['email'] + '</div>');
            }
            else {
                emailElement.parent().children('.invalid-form-element-error').show();
            }
        }
        else {
            emailElement.removeClass('invalid-form-element');
            emailElement.parent().children('.invalid-form-element-error').hide();
        }
    }
};

function postcode_validation(form) {
    if (Settings.validate_zips) {
        var postcodeElement = form.find('.js-member-postcode input');
        if (postcodeElement.length && postcodeElement.attr('required')) {
            var postcode = postcodeElement.val().replace(/\s/g, "");
            var regex = Settings.zip_format[Settings.zip];
            if (!regex.test(postcode)) {
                $(postcodeElement).addClass('invalid-form-element');
                $(postcodeElement).parent().show();
                if (postcodeElement.parent().children('.invalid-form-element-error').length == 0) {
                    $(postcodeElement).parent().append(
                        '<div class="invalid-form-element-error">' + Settings.validation_errors['postcode'] + '<br/><a href="#" class="js-not-from-uk">' + Settings.validation_errors['not_from_here'] + '</a></div>'
                    );
                    $(postcodeElement).parent().append(
                        '<div class="not-from-uk js-not-from-uk-text">' + Settings.validation_errors['not_from_here_explanation'] + '</div>'
                    );
                    $('.js-not-from-uk').on('click', function (e) {
                        e.preventDefault();
                        $(this).hide();
                        $('.js-not-from-uk-text').show();
                    });
                }
                else {
                    postcodeElement.parent().children('.invalid-form-element-error').show();
                }
            }
            else {
                postcodeElement.removeClass('invalid-form-element');
                postcodeElement.parent().children('.invalid-form-element-error').hide();
            }
        }
    }
};

function show_validation_error(element, show, error) {
    if (show) {
        if (element.children('.invalid-form-element-error').length == 0) {
            element.append('<div class="invalid-form-element-error">' + error + '</div>');
        }
    } else {
        element.children('.invalid-form-element-error').remove();
    }
};

function validate_or_alert(element, errors_name, parent_selector) {
    if (element) {
        if (parent_selector) {
            var form = element.closest('form');
            parent = element.closest(parent_selector, form);
        } else {
            parent = element.parent();
        }
        var error_message = element.attr('data-error-msg') || Settings.validation_errors[errors_name]
        show_validation_error(parent, !element.checkValidity(), error_message);
    }
};

function hide_known_member_data() {
  $('form').each(function() {

    var known_member_data = $(this).find('input[name=known_member_data]');
    var known_member_data_arr = (known_member_data && known_member_data.val() ? known_member_data.val().split(',') : []);

    $(this).find('.hideIfComplete, .member-is-known .hideIfMemberKnown').each(function () {

      var input_field = $(this).children('select, input').first();
      var field_container = $(this).parent();

      // Hide if this is known data (special case the 'name' field as this is split into two in the session)
      var field_known = false;
      var name_regex_result = (input_field.attr('name') || "").match(/\[(.*)\]/);
      var rthing_field_name = ( (name_regex_result && name_regex_result.length === 2) ? name_regex_result[1] : "");
      if (rthing_field_name === "name") {
        field_known = known_member_data_arr.includes("firstname") || known_member_data_arr.includes("lastname");
      } else {
        field_known = known_member_data_arr.includes(rthing_field_name);
      }

      if (field_known) {
        field_container.hide();
        input_field.attr('disabled', true); //Disable hidden fields so they're not validated by form.checkValidity()
      }
    });
  });
}

/*
 * Consent logic
 */
function preSubmitConsentLogic(form, ev) {
  if (showConsentPopup(form)) {
    ev.preventDefault();
  } else {
    hideConsentInputsOnDaisyChainedActions(form);
  }
}


function showConsentInputs() {
  $('.consent').removeClass('hidden');
  // Also need to re-enable inputs so they are validated and form data submitted
  $('.consent input').removeAttr('disabled');
}

function hideConsentInputsOnDaisyChainedActions(form) {
  // Don't hide/disable the elements in the current form, or consent data won't be submitted during the current button press!
  $('.consent.hide-on-daisy-chain').not(form.find('*')).addClass('hidden');
  $('.consent.hide-on-daisy-chain input').not(form.find('*')).attr('disabled', true);
}


function showConsentPopup(form) {
  if (form.find('input[type=hidden][value=popup-ask]').not('input[disabled]').length > 0) {
    form.find('.consent-modal').modal( {backdrop:'static', keyboard:false} );
    return true;
  }
  return false;
}

$(function() {
  $('.js-popup-consent-button').on('click', function(ev){
    var form = $(this).closest('form');
    var inputName = $(this).attr('name');
    var inputValue = $(this).attr('value');

    // Set the value of the hidden consent field to the value of the clicked button
    form.find('input[type=hidden][name="' + inputName + '"]').val(inputValue);

    hideConsentInputsOnDaisyChainedActions(form);
    form.find('.consent-modal').modal('hide');
    form.submit();
  });
});

$(function() {
  $('.consent input[type=radio]').on('click', function(ev){
    var radio_button_div = $(this).closest('div.radio_button');
    var inputValue = $(this).attr('value');

    // Hide other warnings
    radio_button_div.find('.radio_button_warning').addClass('hidden');
    // Show warning for this option (if any)
    console.log("Searching for: " + '.radio_button_warning.' + inputValue)
    radio_button_div.find('.radio_button_warning.' + inputValue).removeClass('hidden');
  });
});



/*** EXPORTS FROM exports-loader ***/
exports["getRecentActions"] = (getRecentActions);
exports["cycleRecentAction"] = (cycleRecentAction);
exports["validateAmount"] = (validateAmount);
exports["getDonationType"] = (getDonationType);
exports["triggerPaypalDonate"] = (triggerPaypalDonate);
exports["standard_validators"] = (standard_validators);
exports["standard_element_validation"] = (standard_element_validation);
exports["email_validation"] = (email_validation);
exports["postcode_validation"] = (postcode_validation);
exports["show_validation_error"] = (show_validation_error);
exports["validate_or_alert"] = (validate_or_alert);
exports["hide_known_member_data"] = (hide_known_member_data);
exports["preSubmitConsentLogic"] = (preSubmitConsentLogic);
exports["showConsentInputs"] = (showConsentInputs);
exports["hideConsentInputsOnDaisyChainedActions"] = (hideConsentInputsOnDaisyChainedActions);
exports["showConsentPopup"] = (showConsentPopup);